import { render, staticRenderFns } from "./FormAddAdmin.vue?vue&type=template&id=5691dfd9&scoped=true"
import script from "./FormAddAdmin.vue?vue&type=script&lang=js"
export * from "./FormAddAdmin.vue?vue&type=script&lang=js"
import style0 from "./FormAddAdmin.vue?vue&type=style&index=0&id=5691dfd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5691dfd9",
  null
  
)

export default component.exports